import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MapsAPILoader } from '@agm/core';
import { CuadreService } from '../../../services/cuadre.service';
import { ConfiguracionesService } from '../../../services/configuraciones.service';
import { Helper } from '../../../helpers/helper';
@Component({
  selector: 'app-recorridos',
  templateUrl: './recorridos.component.html',
  styleUrls: ['./recorridos.component.css']
})
export class RecorridosComponent implements OnInit {
  zoom = 18;
  lat = 18.848449;
  lng = -70.9046499;
  markers: any;
  @Input() ID_APERTURA: any;
  public polyline: Array<any>;
  public polylines: Array<any>;
  public maxSpeed: number;
  changeDetection: ChangeDetectionStrategy.OnPush;
  urlImg: string;
  constructor(
    public activeModal: NgbActiveModal,
    private mapsAPILoader: MapsAPILoader,
    private cuadreService: CuadreService,
    private helper: Helper,
    private configuracionesService: ConfiguracionesService) {
      this.urlImg = this.helper.urlImg + 'cedulas/';
      this.initConfigs();
    }

  ngOnInit() {
    this.initRecorrido();
  }

  private initConfigs(): void {
    this.configuracionesService.obtenerConfiguraciones().subscribe((res: any) => this.maxSpeed = res.limite_velocidad);
    // this.maxSpeed = 80;
  }

  private rebuildPolylines() {
    const polylines = [];
    let i = 0;
    let newPolyline = {path: [], color: '#7DC500'};
    for (const point of this.polyline) {
      newPolyline.path.push(point);
      // tslint:disable-next-line:max-line-length
      const speedChanged = this.polyline[i + 1] && (point.speed < this.maxSpeed && this.polyline[i + 1].speed < this.maxSpeed) || (point.speed > this.maxSpeed && this.polyline[i + 1].speed > this.maxSpeed );
      if (point.speed > this.maxSpeed) {
        newPolyline.color = '#D12939';
      }
      if (speedChanged) {
        newPolyline.path.push( this.polyline[i + 1] );
        polylines.push(newPolyline);
        newPolyline = {path: [], color: '#7DC500'};
      }
      i++;
    }
    return polylines;
  }

  private initRecorrido(): void {
    this.cuadreService.obtenerRecorrido(this.ID_APERTURA)
    .subscribe((res: any) => {
      if (res) {

        this.polyline = res.data;
        this.lat = res.data[0].lat;
        this.lng = res.data[0].lng;
        this.markers = res.markers;
        this.polylines = this.rebuildPolylines();
        this.mapsAPILoader.load();
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/recorridos/recorridos.component.ts